import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import { Resource } from '../../../httpClient/resources/Resource';
import { GetSiteNamesRequest, IGetSiteNamesResult } from '../../serverApi/requests/GetSiteNamesRequest';
import { ISiteNameWithId } from '../../serverApi/types/ISiteNameWithId';

export class SiteNameWithIds extends Resource<ISiteNameWithId> {

  public static readonly instance = new SiteNameWithIds(new WebClientListResourceFetcher(GetSiteNamesRequest, (result: IGetSiteNamesResult) => {
    return result.siteNames;
  }));

}
